import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import TrainerTermsContent from "./TrainerTermsContent";

const TrainerTermsAndConditions: React.FC = () => {
  return (
    <LegalPageLayout title="Pheefee Trainer Terms and Conditions" lastUpdated="April 17, 2026">
      <TrainerTermsContent />
    </LegalPageLayout>
  );
};

export default TrainerTermsAndConditions;
